// extracted by mini-css-extract-plugin
export var container = "_7n-0";
export var error = "_7n-9";
export var label = "_7n-5";
export var light = "_7n-6";
export var md = "_7n-3";
export var sm = "_7n-2";
export var thin = "_7n-8";
export var thinBold = "_7n-7";
export var vertical = "_7n-4";
export var xs = "_7n-1";